import {useSelector} from "react-redux";
import {MODE_TYPE} from "utils";

export const useGetStudioMode = () => {
  const mode = useSelector(state => state.mode.studioMode);
  const isEditMode = mode === MODE_TYPE.EDIT_MODE;

  return {isEditMode};
};
